var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEnded)?_c('div',[_c('strong',[_vm._v(_vm._s(_vm.nameField))]),_vm._v(" Закончилась\n")]):_c('div',[_c('strong',[_vm._v(_vm._s(_vm.nameField)+" ")]),_vm._v(_vm._s(_vm.days)+" "+_vm._s(_vm.hours)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }